import React from 'react';
import './CellStatus.css';

const CellStatus = ({
    text = '',
    color = '',
}) => (
    <span className={`table-cell_status table-cell_status-${color}`}>
        {text}
    </span>
);

export default CellStatus;
